module.exports = __webpack_public_path__ + "img/img4.fe75192d.png";